import React from 'react';
import { Card } from './ui/Card';
import { MOCK_GUARDS } from '../utils/mockData';
import { Badge } from './ui/Badge';
import { format } from 'date-fns';
import { ShieldAlert } from 'lucide-react';
export function GuardRoster() {
  const missingExit = MOCK_GUARDS.find(g => g.status === 'Missing Exit');
  return <Card className="h-full flex flex-col" data-id="element-87">
      <div className="mb-4 flex items-center justify-between" data-id="element-88">
        <h2 className="text-lg font-semibold text-white" data-id="element-89">Guards on Duty</h2>
        <Badge variant="outline" data-id="element-90">Face ID Verified</Badge>
      </div>

      {missingExit && <div className="mb-4 flex items-center gap-3 rounded-md bg-red-500/10 border border-red-500/20 p-3 text-red-500" data-id="element-91">
          <ShieldAlert className="h-5 w-5 flex-shrink-0" data-id="element-92" />
          <div className="text-sm" data-id="element-93">
            <span className="font-semibold" data-id="element-94">Alert:</span> {missingExit.name}{' '}
            missing exit scan.
          </div>
        </div>}

      <div className="space-y-3" data-id="element-95">
        {MOCK_GUARDS.filter(g => g.status !== 'Missing Exit').map(guard => <div key={guard.id} className="flex items-center gap-3 rounded-lg bg-gray-900/50 p-3 border border-gray-800" data-id="element-96">
            <div className="relative h-10 w-10 flex-shrink-0" data-id="element-97">
              <img src={guard.photoUrl} alt={guard.name} className="h-full w-full rounded-full object-cover border border-gray-700" data-id="element-98" />
              <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-[#1a1d23]" data-id="element-99" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-100">
              <div className="flex justify-between items-start" data-id="element-101">
                <h4 className="font-medium text-white truncate" data-id="element-102">
                  {guard.name}
                </h4>
                <span className="text-xs text-gray-500" data-id="element-103">
                  ID: {guard.id.toUpperCase()}
                </span>
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-400 mt-0.5" data-id="element-104">
                <span data-id="element-105">Since {format(guard.onDutySince, 'HH:mm')}</span>
                <span data-id="element-106">•</span>
                <span data-id="element-107">Last check: {format(guard.lastCheckIn, 'HH:mm')}</span>
              </div>
            </div>
          </div>)}
      </div>
    </Card>;
}